import { ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { Ban, Check, Info, TriangleAlert, X } from 'lucide-react'

const icons = {
  info: <Info className="size-5" />,
  success: <Check className="size-5" />,
  warning: <TriangleAlert className="size-5" />,
  error: <Ban className="size-5" />,
}

export const Alert = ({
  className,
  variant,
  children,
  onClose,
}: {
  className?: string
  variant: 'info' | 'warning' | 'success' | 'error'
  children: ReactNode
  onClose?: () => void
}) => {
  const isClosable = !!onClose

  return (
    <aside
      role="alert"
      className={cn(
        'relative w-full rounded-2xl px-4 py-2 [&_a]:underline',
        { 'bg-blue-100': variant === 'info' },
        { 'bg-green-200': variant === 'success' },
        { 'bg-yellow-200': variant === 'warning' },
        { 'bg-red-200': variant === 'error' },
        className,
      )}
    >
      <i className="absolute left-3 top-3">{icons[variant]}</i>
      <div className={cn('ml-6 mt-[1px]', { 'mr-6': isClosable })}>{children}</div>
      {isClosable && (
        <button
          type="button"
          className="absolute right-3 top-2 flex rounded-xl p-1 hover:bg-[rgba(0,0,0,.05)]"
          onClick={() => onClose?.()}
          title="Lukk beskjed"
        >
          <X className="size-5" />
        </button>
      )}
    </aside>
  )
}
